import type { CommunityDetail } from '@pba/react-network';
import { useTranslation } from 'react-i18next';
import { usePermissions } from 'permissions';
import { Card, Col, Row } from 'ui';
import { ContentObjectFeed, CreateContentObjectTrigger } from 'features/feed';

export type P = {
  community: CommunityDetail;
};

const CommunityFeedContent = ({ community }: P) => {
  const { t } = useTranslation();
  const { canCreatePostInCommunity } = usePermissions();

  return (
    <Row gutter={[0, 'ms']}>
      {canCreatePostInCommunity({ community }) ? (
        <Col span={24}>
          <Card marginBottom={false}>
            <CreateContentObjectTrigger initialCommunity={community} />
          </Card>
        </Col>
      ) : null}
      {/* TODO: Will be used in Task #87927 for Community feed pinned posts */}
      <Col span={24}>
        <ContentObjectFeed
          communityId={community.id}
          emptyState={{
            description: {
              title: t('This community has no content.'),
            },
          }}
          pinned={false}
        />
      </Col>
    </Row>
  );
};

export default CommunityFeedContent;
